import { render, staticRenderFns } from "./StringsForTest.vue?vue&type=template&id=1018762d&scoped=true&"
import script from "./StringsForTest.vue?vue&type=script&lang=js&"
export * from "./StringsForTest.vue?vue&type=script&lang=js&"
import style0 from "./StringsForTest.vue?vue&type=style&index=0&id=1018762d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018762d",
  null
  
)

export default component.exports